/**
 * Shares the step field this person is typing in (`editing` in their
 * presence), so eve's edits to it are refused while they type: the person's
 * words win before eve writes, not only after. A field is an element in the
 * step's editor marked `data-step-field="label"` or `"config.<key>"`.
 *
 * @module components/workflows/StepFieldScope
 */
import type { WorkflowPresenceState } from "@amoreg/contracts";
import { type ReactNode, useEffect } from "react";

import { stepFieldOf } from "./StepFieldScope.logic";

/** Around one step's editor: focusing a field shares it, leaving it or closing the editor clears it. */
export function StepFieldScope({
  stepId,
  publish,
  children,
}: {
  readonly stepId: string;
  readonly publish: (patch: Partial<WorkflowPresenceState>) => void;
  readonly children: ReactNode;
}) {
  useEffect(() => () => publish({ editing: null }), [publish, stepId]);
  return (
    <div
      className="contents"
      onFocus={(event) => {
        const field = stepFieldOf(event.target);
        publish({ editing: field === null ? null : { stepId, field } });
      }}
      onBlur={() => publish({ editing: null })}
    >
      {children}
    </div>
  );
}
